<template>
    <v-select
        :value="selectedValues"
        :items="items"
        item-text="name"
        item-value="value"
        aria-label="Send To"
        multiple
        small-chips
        clearable
        outlined
        dense
        @input="updateSelection"
    >
        <template v-slot:item="{ item, attrs, on }">
            <v-list-item
                v-bind="attrs"
                :input-value="isSelected(item)"
                :aria-selected="String(isSelected(item))"
                :class="{ 'pl-8': !item.users }"
                v-on="on"
            >
                <v-list-item-action>
                    <v-simple-checkbox
                        :value="isSelected(item)"
                        :indeterminate="isIndeterminate(item)"
                        :ripple="false"
                        color="primary"
                        @input="on.click"
                    ></v-simple-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title :class="{ 'font-weight-bold': item.users }">
                        {{ item.name }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-select>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => []
            },
            users: {
                type: Array,
                default: () => []
            }
        },

        computed: {
            selectedValues() {
                return this.value.map(String);
            },

            items() {
                const groups = new Map();

                this.users.forEach(user => {
                    const profileName = user.profileName || 'Unassigned';
                    if (!groups.has(profileName)) {
                        groups.set(profileName, []);
                    }
                    groups.get(profileName).push({
                        value: String(user.id),
                        name: user.name || user.profileName || 'User'
                    });
                });

                const items = [];
                groups.forEach((users, profileName) => {
                    items.push({
                        value: `profile-${profileName}`,
                        name: profileName,
                        users
                    }, ...users);
                });
                return items;
            }
        },

        methods: {
            isSelected(item) {
                return item.users
                    ? item.users.every(user => this.selectedValues.includes(user.value))
                    : this.selectedValues.includes(item.value);
            },

            isIndeterminate(item) {
                return Boolean(item.users &&
                    !this.isSelected(item) &&
                    item.users.some(user => this.selectedValues.includes(user.value)));
            },

            updateSelection(values) {
                const selected = new Set(values);
                const group = this.items.find(item => item.users && selected.has(item.value));

                if (group) {
                    selected.delete(group.value);
                    const deselect = this.isSelected(group);
                    group.users.forEach(user => {
                        if (deselect) {
                            selected.delete(user.value);
                        } else {
                            selected.add(user.value);
                        }
                    });
                }

                this.$emit('input', this.users
                    .filter(user => selected.has(String(user.id)))
                    .map(user => user.id));
            }
        }
    };
</script>
